import { oc } from '@orpc/contract';
import { trackerGridInputSchema, trackerGridOutputSchema } from '../schemas/tracker.schemas.js';
export const getTrackerGridContract = oc
    .route({
    method: 'GET',
    path: '/tracker/grid',
    tags: ['Tracker'],
    summary: 'The weekly grid for a From→To range (≤ 104 weeks, never reversed) or all weeks, scoped to the pillars the caller may see',
})
    .input(trackerGridInputSchema)
    .output(trackerGridOutputSchema);
//# sourceMappingURL=get-tracker-grid.contract.js.map